import { LiquiditySourceFactory } from './liquidity-source.factory';
import { Fill } from '../model';
import { FillDto } from '../dto';
import { SimpleTokenFactory } from './simple-token.factory';

export class FillFactory {
  public static createFromDto(dto: FillDto): Fill {
    const fill = new Fill();
    fill.liquiditySource = LiquiditySourceFactory.createSimpleFromDto(
      dto.liquiditySource,
    );
    fill.proportionInBps = dto.proportionInBps;
    if (dto.from) {
      fill.from = SimpleTokenFactory.createFromDto(dto.from);
    }
    if (dto.to) {
      fill.to = SimpleTokenFactory.createFromDto(dto.to);
    }
    fill.subFills = dto.subFills?.map(subFill => this.createFromDto(subFill));
    return fill;
  }
}
